import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import H2 from '@base/H2/H2';
import H4 from '@base/H4/H4';
import P1 from '@base/P1/P1';
import Image from '@base/Image';
import { breakpoints, Spacings } from '@styles/index';
import useScholarshipTestInfo from '@api/hooks/scholarship/useScholarshipTestInfo';

const Wrapper = styled.div`
  background: var(--color-i-gray-10);
  padding-top: 110px;
  padding-bottom: 110px;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    padding: ${Spacings.SPACING_4B};
    margin-top: ${Spacings.SPACING_13B};
  }
`;

const Content = styled.div`
  max-width: 1136px;
  margin: auto;
  h2 {
    width: 35%;
    @media only screen and (max-width: ${breakpoints.tablet}) {
      width: 90%;
    }
  }
`;

const Title = styled(H2)`
  margin-bottom: ${Spacings.SPACING_12B};
`;

const Points = styled.div`
  display: flex;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
  }
`;

const AboutPoint = styled.div`
  margin-right: ${Spacings.SPACING_15B};
  flex: 1;
  :last-child {
    margin-right: 0px;
  }
  @media only screen and (max-width: ${breakpoints.tablet}) {
    margin-right: 0px;
    margin-bottom: ${Spacings.SPACING_10B};
  }
`;

const PointTitle = styled(H4)`
  margin-top: ${Spacings.SPACING_4B};
  margin-bottom: ${Spacings.SPACING_2B};
`;

const KeyPoints = () => {
  const {
    query: { eventKey }
  } = useRouter();
  const { prodigyInfo } = useScholarshipTestInfo(eventKey);

  const { keyPointsHeaderText, keyPoints } = prodigyInfo;

  return (
    <Wrapper>
      <Content>
        <Title>{keyPointsHeaderText}</Title>
        <Points>
          {keyPoints.map((point) => (
            <AboutPoint key={`point-${point.id}`}>
              <Image src={point.image} alt="key-point" height={80} width={80} />
              <PointTitle>{point.title}</PointTitle>
              <P1>{point.subTitle}</P1>
            </AboutPoint>
          ))}
        </Points>
      </Content>
    </Wrapper>
  );
};

export default KeyPoints;
